module.exports = __webpack_public_path__ + "add8c8dc1e172a666a8109c226ce87cf.pdf";